import GeneralInput from './generalInput.js';

export default GeneralInput;